import { XpEarnedMetadata } from "../badgeNotificationKey";

type XpEarnedViewProps = {
    title: string;
    description: string;
    metadata: XpEarnedMetadata;
};

export function XpEarnedView({ title, description, metadata }: XpEarnedViewProps) {
    const earnedXp = metadata.display_xp;
    return (
        <div className="relative flex flex-col gap-6 items-center justify-center">
            <div className="text-green-700 text-[30px] font-semibold leading-[24px] mt-24">
                +{earnedXp ?? 0} XP
            </div>
            <div className="flex flex-col gap-1 items-center mt-12">
                <span className="text-lg font-semibold leading-[27px] text-black">{title}</span>
                <span className="text-sm text-black">{description}</span>
            </div>
        </div>
    );
}
